import { DataSource } from 'hooks/useHttpClient';
import { MappedEntityType } from '..';

const MICRO_V3_PATHS = [
    MappedEntityType.LoginResponse,
    MappedEntityType.GetPermissions,
    MappedEntityType.PostCreateNewUser,
    MappedEntityType.GoogleResponse
];

export default function getDataSource(mappedType: MappedEntityType): DataSource {
    if (MICRO_V3_PATHS.includes(mappedType)) {
        return 'micro-v3';
    }
    return 'hyrerocket';
}
